module.exports = __webpack_public_path__ + "static/media/success.a36ad6b1.svg";